import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, switchMap, tap } from 'rxjs';
import { LocalStorageService } from 'src/app/shared/localstorage.service';
import { SettingsService } from 'src/app/features/settings/services/settings.services';
import {
  loadFieldVisibilityCatalog,
  loadFieldVisibilityCatalogFailure,
  loadFieldVisibilityCatalogSuccess,
  loadHiddenFieldsFromLogin,
} from './field-visibility.actions';
import { IFieldVisibilityCatalog } from './field-visibility.types';

@Injectable()
export class FieldVisibilityEffects {
  constructor(
    private readonly actions$: Actions,
    private readonly settingsService: SettingsService
  ) {}

  loadCatalog$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadFieldVisibilityCatalog),
      switchMap(() =>
        this.settingsService.getFieldVisibilityCatalog().pipe(
          map((response) => {
            const catalog =
              (response?.object as IFieldVisibilityCatalog | undefined) ??
              ({
                order: { system: [], custom: [] },
                product: { system: [], custom: [] },
                company: { system: [], custom: [] },
              } as IFieldVisibilityCatalog);
            return loadFieldVisibilityCatalogSuccess({ catalog });
          }),
          catchError(() => [loadFieldVisibilityCatalogFailure()])
        )
      )
    )
  );

  persistHiddenFields$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(loadHiddenFieldsFromLogin),
        tap(({ hiddenFields }) => {
          const currentUser = LocalStorageService.get('currentUser');
          if (!currentUser?.access_token || !currentUser?.user) {
            return;
          }
          LocalStorageService.put('currentUser', {
            ...currentUser,
            user: {
              ...currentUser.user,
              hidden_fields: hiddenFields,
            },
          });
        })
      ),
    { dispatch: false }
  );
}
